import { useDispatch, useSelector } from 'react-redux';
import { useSetLanguageEvent, setDocumentLanguage } from '@helsenorge/framework-utils/hn-language';
import { selectCurrentLanguage, selectLanguages, languageChanged } from '@helsenorge/framework-utils/language';
/**
 * useLanguageEvent lytter på global språkbytte-event og oppdater document language og global state
 * @param callback Optional callback som må returnere true for at hooken skal oppdatere språket. Brukes for å unngå at store oppdateres unødvendig mange ganger.
 */
const useLanguageEvent = (callback) => {
    const dispatch = useDispatch();
    const currentLanguage = useSelector(state => selectCurrentLanguage(state.language));
    const supportedLanguages = useSelector(state => selectLanguages(state.language));
    useSetLanguageEvent((newLanguage, options) => {
        if (callback && !callback(options)) {
            return;
        }
        if (newLanguage === currentLanguage) {
            return;
        }
        if (!supportedLanguages.includes(newLanguage)) {
            return;
        }
        // @todo: Fjern kallet til setDocumentLanguage i v35, dette håndteres nå i reduceren
        setDocumentLanguage(newLanguage);
        dispatch(languageChanged(newLanguage));
    });
};
export default useLanguageEvent;
